import React from 'react'
import { Link } from 'react-router-dom'
import AdminMenu from '../components/AdminMenu'; // ajusta la ruta si estás en una subcarpeta


function AdminDashboard() {
  return (
    <div className="admin-dashboard">
      <h2>Panel de Administrador</h2>
      <ul>
        <li><Link to="/admin/sesiones">Sesiones Activas</Link></li>
        <li><Link to="/admin/usuarios">Gestión de Usuarios</Link></li>
        <li><Link to="/admin/peticiones">Gestión de Peticiones</Link></li>
        <li><Link to="/admin/ampliaciones">Gestión de Ampliaciones</Link></li>
        <li><Link to="/admin/favoritos">Favoritos</Link></li>
        <li><Link to="/admin/logros">Logros</Link></li>
        <li><Link to="/admin/misiones">Misiones</Link></li>
        <li><Link to="/admin/medallas">Medallas</Link></li>
        <li><Link to="/admin/noticias">Noticias</Link></li>
        <li><Link to="/admin/actividad">Actividad de Usuarios</Link></li>
      </ul>
    </div>
  )
}

export default AdminDashboard
